module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/start-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/start-up@3x.png
// module id = 736
// module chunks = 0